/* unplugin-vue-components disabled */import { render } from "./simple-footer.vue?vue&type=template&id=0616de97&scoped=true&ts=true"
import script from "./simple-footer.vue?vue&type=script&lang=ts"
export * from "./simple-footer.vue?vue&type=script&lang=ts"

import "./simple-footer.vue?vue&type=style&index=0&id=0616de97&lang=less&scoped=true"

import exportComponent from "/Users/fiture/Fiture/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0616de97"]])

export default __exports__